import {CacheState} from "./CacheState";
import {ReportFull} from "../../model/report/ReportFull";

export class ReportFullState implements CacheState {
    constructor(public reportFull: ReportFull | null = null,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}